// import { useState } from "react";
import { useEffect, useState, useRef } from "react";
import "../CSS/Login.css";
import api from "../api";

// ── Searchable combobox for Financial Year ──────────────────────────────
function FinYearCombobox({ value, onChange, options }) {
  const [open,        setOpen]        = useState(false);
  const [query,       setQuery]       = useState("");
  const [cursor,      setCursor]      = useState(0);
  const wrapRef  = useRef(null);
  const inputRef = useRef(null);
  const dropRef  = useRef(null);

  const selectedLabel = options.find(o => o.value === value)?.label || "";

  // Sync display text when value changes from outside
  useEffect(() => { if (!open) setQuery(selectedLabel); }, [open, selectedLabel]);
  useEffect(() => { setQuery(selectedLabel); }, [selectedLabel]);

  // Close on outside click
  useEffect(() => {
    function handleClick(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick, true);
    return () => document.removeEventListener("mousedown", handleClick, true);
  }, []);

  // Scroll highlighted item into view
  useEffect(() => {
    if (open && dropRef.current) {
      const el = dropRef.current.children[cursor];
      if (el) el.scrollIntoView({ block: "nearest" });
    }
  }, [cursor, open]);

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes((query || "").toLowerCase())
  );

  function choose(opt) {
    onChange(opt.value);
    setQuery(opt.label);
    setOpen(false);
  }

  function handleKeyDown(e) {
    if (!open) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") { setOpen(true); }
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setCursor(c => Math.min(c + 1, filtered.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setCursor(c => Math.max(c - 1, 0));
    } else if (e.key === "Escape") {
      setOpen(false);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (filtered[cursor]) choose(filtered[cursor]);
      setOpen(false);
    }
  }

  return (
    <div className="fy-combo-wrap" ref={wrapRef}>
      <input
        ref={inputRef}
        type="text"
        className="login-input fy-combo-input"
        placeholder="Search financial year…"
        value={open ? query : selectedLabel}
        autoComplete="off"
        spellCheck={false}
        onFocus={() => { setOpen(true); setQuery(""); setCursor(0); }}
        onClick={() => { if (!open) { setOpen(true); setQuery(""); } }}
        onChange={e => { setQuery(e.target.value); setOpen(true); setCursor(0); }}
        onKeyDown={handleKeyDown}
      />
      <span
        className="fy-combo-chevron"
        onMouseDown={e => { e.preventDefault(); setOpen(o => !o); inputRef.current?.focus(); }}
      >&#9662;</span>
      {open && filtered.length > 0 && (
        <div className="fy-combo-drop" ref={dropRef}>
          {filtered.map((opt, i) => (
            <div
              key={opt.value}
              className={`fy-combo-opt${opt.value === value ? " sel" : ""}${cursor === i ? " foc" : ""}`}
              onMouseDown={e => { e.preventDefault(); choose(opt); }}
              onMouseEnter={() => setCursor(i)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
      {open && filtered.length === 0 && (
        <div className="fy-combo-drop">
          <div className="fy-combo-empty">No match</div>
        </div>
      )}
    </div>
  );
}

export default function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [finYears, setFinYears] = useState([]);
  const [finYearCode, setFinYearCode] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
  loadFinancialYears();
}, []);
const loadFinancialYears = async () => {
  try {
    const res = await api.get("/dropdown?mode=FY");
    const data = res.data;
    setFinYears(data);
    if (data && data.length > 0) {
      const first = data[0];
      // Find key case-insensitively since backend returns Dictionary with SQL casing
      const codeKey = Object.keys(first).find(k => k.toLowerCase() === "finyear_code") || Object.keys(first)[0];
      console.log("FY data[0]:", first, "codeKey:", codeKey, "value:", first[codeKey]);
      setFinYearCode(String(first[codeKey]));
    }
  } catch (error) {
    console.log(error);
  }
};
  const handleLogin = async () => {
    if (!username.trim()) {
      setError("Please enter username.");
      return;
    }

    if (!password.trim()) {
      setError("Please enter password.");
      return;
    }

    // if (!finYearCode) {
    //   setError("Please select a financial year.");
    //   return;
    // }

    try {
      const payload = {
        username: username.trim(),
        password: password.trim(),
        finYearCode: finYearCode || null
      };
      console.log("Login payload:", payload); // debug — remove after fix confirmed
      const res = await api.post("/login", payload);

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("token", res.data.accessToken);
      localStorage.setItem("sessionToken", res.data.sessionToken);
      localStorage.setItem("username", username); // Store username for display
      localStorage.setItem("loginTime", Date.now());

      setIsLoggedIn(true);
       window.location.reload(); //adding for concurrent login
    } 
    // catch (err) {
    //   setError("Invalid username or password");
    // }
    catch (err) {
  setError(
    err.response?.data?.message || "Login failed"
  );
}
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* ── Company Header ── */}
        <div className="login-company">
          <div className="login-logo-icon">🚚</div>
          <div className="login-company-text">
            <div className="login-company-name">SAAMI TRADESTAR</div>
            <div className="login-company-sub">Logistics Ltd</div>
          </div>
        </div>

        {/* ── ILMS Band ── */}
        <div className="login-ilms-band">
          <span className="login-ilms-name">ILMS</span>
          <span className="login-ilms-full">Innovative Logistics Management System</span>
        </div>

        {/* ── Welcome Heading ── */}
        <div className="login-welcome">
          <div className="login-welcome-title">
            Welcome <span>Back</span>
          </div>
          <div className="login-welcome-sub">
            Sign in to your account to continue
          </div>
        </div>

        {/* ── Form ── */}
        <div className="login-form">

          {/* Username */}
          <div className="login-field">
            <label className="login-label">Username</label>
            <div className={`login-input-wrap${error && !username.trim() ? " error" : ""}`}>
              <span className="login-input-icon">👤</span>
              <input
                className="login-input"
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={e => { setUsername(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                autoComplete="username"
              />
            </div>
          </div>

          {/* Password */}
          <div className="login-field">
            <label className="login-label">Password</label>
            <div className={`login-input-wrap${error && !password.trim() ? " error" : ""}`}>
              <span className="login-input-icon">🔒</span>
              <input
                className="login-input"
                type={showPass ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                autoComplete="current-password"
              />
              <span
                className="login-input-icon"
                style={{ cursor: "pointer", color: "var(--muted)", userSelect: "none" }}
                onClick={() => setShowPass(v => !v)}
                title={showPass ? "Hide password" : "Show password"}
              >
                {showPass ? "🙈" : "👁️"}
              </span>
            </div>
          </div>
           
          <div className="login-field">
            <label className="login-label">Financial Year</label>
            <div className="login-input-wrap" style={{ overflow: "visible", position: "relative" }}>
              <span className="login-input-icon">📅</span>
              <FinYearCombobox
                value={finYearCode}
                onChange={setFinYearCode}
                options={finYears.map(item => {
                  const codeKey  = Object.keys(item).find(k => k.toLowerCase() === "finyear_code")  || Object.keys(item)[0];
                  const labelKey = Object.keys(item).find(k => k.toLowerCase() === "financialyearperiod") || Object.keys(item)[1];
                  return { value: String(item[codeKey]), label: item[labelKey] };
                })}
              />
            </div>
          </div>

          {/* Error message */}
          {error && <div className="login-error-msg">⚠️ {error}</div>}

          {/* Forgot password */}
          <div className="login-forgot">
            <a href="#">Forgot password?</a>
          </div>

          {/* Login Button */}
          <button className="login-btn" onClick={handleLogin}>
            🔐 &nbsp;Login
          </button>

        </div>

        {/* ── Footer ── */}
        <div className="login-footer">
          <span className="status-dot" style={{ marginRight: 6 }} />
          © 2026 <strong>Saami Tradestar Logistics Ltd</strong> &nbsp;·&nbsp; ILMS v2.4.1
        </div>

      </div>
    </div>
  );
  //comment
}